// @flow

import React from 'react'

export type PropTypes = {
  entry: {
    title: string,
    description: string,
    url: string,
    image: string,
  },
}

export default (props: Object) => {
  const { entry } = props
  if (entry) {
    return (
      <section className="space-main__section clearfix space-main__case">
        <h2 className="space-main__headline">{i18n.t('page.room.beyond')}</h2>
        <div className="col-xs-12 col-sm-5">
          <a href={entry.url} target="_blank">
            <img src={entry.image} alt="" className="w100pa is-hover" />
          </a>
        </div>
        <div className="col-xs-12 col-sm-7">
          <h3 className="space-main__case-title">
            <a href={entry.url} target="_blank" className="a__underline">
              {entry.title}
            </a>
          </h3>
          <p className="sm-hide">{entry.description}</p>
        </div>
      </section>
    )
  }

  return null
}



// WEBPACK FOOTER //
// ./src/components/organisms/room/DetailUsecaseSection/index.jsx